import React from 'react';
import Img from 'gatsby-image';
import WithPicLayout from '../layout/WithPicLayout';
import PrenotaOra from '../prenotaOra';

const IntroductionSection = ({ section, image, showCTA = false, imagePosition = 'right' }) => {
  const content = (
    <>
      <p>
        <strong>{section.title}</strong>
        <br />
        {section.content}
      </p>
      {showCTA && section.cta && (
        <div className='call-to-action'>
          <PrenotaOra text={section.cta.text} />
        </div>
      )}
    </>
  );

  if (image) {
    return (
      <WithPicLayout image={image} imagePosition={imagePosition}>
        {content}
      </WithPicLayout>
    );
  }

  return <div>{content}</div>;
};

export default IntroductionSection;